import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [e_countries] = useParameter<number[]>("@e_countries");
  const [calendar] = useParameter<number[]>("@calendar");
  const [eCalendar] = useParameter<number[]>("@e_calendar");
  const [e_yield_calendar] = useParameter<number[]>("@e_yield_calendar");

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commDisplay, setCommDisplay] = useParameter<string[]>("@commodities_display");
  const [units, setUnits] = useParameter<number[]>("@units");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@business-units": business,
      "@commodities": commodities,
      "@commodities_display": commDisplay,
      "@calendar": calendar,
      "@e_countries": e_countries,
      "@e_calendar": eCalendar,
      "@e_yield_calendar": e_yield_calendar,
      "@units": units,
    });
  }, [title, subtitle, business, eCalendar, commDisplay, calendar, commodities, units, e_countries, e_yield_calendar, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setBusiness((parameters["@business-units"].value as string[]).map(Number)[0]);
      setCommodities((parameters["@commodities"].value as string[]).map(Number));
      setCommDisplay(parameters["@commodities_display"].value as string[]);
      setUnits((parameters["@units"].value as string[]).map(Number));
    },
    [setBusiness, setCommodities, setCommDisplay, setUnits]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
